import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/comunidade")({
  head: () => ({
    meta: [
      { title: "Comunidade — Viny Club" },
      {
        name: "description",
        content: "O feed da comunidade de colecionadores: posts, fotos e vídeos de discos.",
      },
      { property: "og:title", content: "Comunidade — Viny Club" },
      {
        property: "og:description",
        content: "O feed da comunidade de colecionadores: posts, fotos e vídeos de discos.",
      },
    ],
  }),
  beforeLoad: () => {
    throw redirect({ to: "/explore", search: { tab: "feed" }, replace: true });
  },
  component: () => null,
});
